module.exports = __webpack_public_path__ + "img/sy.a128f999.png";